import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../ui/theme/colors';

export const useLockerTimelineCardStyles = makeStyles((theme) => ({
  card: {
    marginTop: '2rem',
    padding: '2rem 2rem 2rem 0',
    minHeight: '350px',
    maxWidth: '900px',
    background: '#fff',
    [theme.breakpoints.down('md')]: {
      marginTop: '16px',
      padding: '16px 16px 16px 0'
    }
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: '12px',
    marginRight: '-2rem',
    paddingLeft: '2rem',
    paddingRight: '2rem',
    borderBottom: `1px solid ${Colors.lightGray}`
  },
  title: {
    fontSize: '12px',
    color: Colors.timelineGray,
    textTransform: 'uppercase',
    margin: 0
  },
  datePicker: {
    '& .MuiPickersInputBase-root': {
      fontSize: '13px'
    },
    maxWidth: '200px'
  },
  calendarIcon: {
    fontSize: '18px',
    color: Colors.timelineGray
  },
  groups: {
    padding: '8px 0'
  },
  empty: {
    textAlign: 'center',
    padding: '32px 0',
    paddingLeft: '2rem',
    color: Colors.midGray,
    fontSize: '14px'
  },
  buttonWrapper: {
    textAlign: 'center',
    padding: '12px 0',
    paddingLeft: '2rem'
  },
  noMoreEvents: {
    fontSize: '13px',
    color: Colors.midGray
  }
}));
